/**
 * Раздел «Конкуренты» — те же конкуренты выбранного бренда, что и во вкладке
 * карточки.
 *
 * Компонент один и тот же намеренно: два экрана с одним смыслом расходятся на
 * первой же правке, а разойтись им здесь нельзя — от признака «отслеживается»
 * зависит, по какой сетке считается доля голоса конкурента.
 */

import { Link } from 'react-router-dom';

import { useAccess } from '../../session';
import { useScope } from '../../scope';
import { Empty, Skeleton } from '../../ui/state';
import { Competitors } from './Competitors';
import { pickBrand } from '../../ui/screen-states';

export function CompetitorsScreen() {
  const scope = useScope();
  const access = useAccess();

  const head = (
    <div className="screen-head">
      <h1>Конкуренты</h1>
      {scope.brand ? (
        <Link className="btn btn-ghost btn-sm" to={`/brands/${scope.brand.id}`}>
          Карточка бренда
        </Link>
      ) : null}
    </div>
  );

  if (scope.state.kind === 'loading') {
    return (
      <>
        {head}
        <Skeleton rows={3} />
      </>
    );
  }

  if (!scope.brandId) {
    return (
      <>
        {head}
        <Empty
          eyebrow="Выберите бренд"
          title="Конкуренты считаются по конкретному бренду"
          action={
            scope.state.kind === 'ready' && scope.liveBrands.length === 0 ? (
              <Link className="btn btn-primary" to="/brands/new">
                Завести бренд
              </Link>
            ) : undefined
          }
        >
          Список собирается из ответов нейросетей на вопросы бренда. {pickBrand()}
        </Empty>
      </>
    );
  }

  return (
    <>
      {head}
      <Competitors
        brandId={scope.brandId}
        readOnly={!access.reaches('POST', '/brands/{brandId}/competitors')}
      />
    </>
  );
}
